import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';

import Utils from 'src/app/utils';

declare var require: any;
import * as _ from 'lodash-es';

@Component({
  selector: 'app-worker-location-settings',
  templateUrl: './worker-location-settings.component.html',
  styleUrls: ['./worker-location-settings.component.scss']
})
export class WorkerLocationSettingsComponent implements OnInit {

  workers: any;

  monitor = '';
  group = '';

  monitors:any = [];
  groups:any = [];

  u = Utils;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService) { }

  ngOnInit(): void {

    this.getWorkers();

  }

  getWorkers(){

    if(this.monitor == null){
      this.monitor = '';
    }

    if(this.group == null){
      this.group = '';
    }

    this.okService.get('reports/workerlocationsettings',{monitor:this.monitor,group:this.group})
    .subscribe((data) => {

      this.workers = _.sortBy(data.body, ['location_active']);
      
      this.groups = this.okService.groups;
      this.monitors = this.okService.monitors;

    });
  }

  updateFilter(){
    this.getWorkers();
  }

  clearFilter(){
    this.monitor = '';
    this.group = '';
    this.updateFilter();
  }

  export(){

    if(this.monitor == null){
      this.monitor = '';
    }

    if(this.group == null){
      this.group = '';
    }

    let fields:any = {'export':true};
    fields['monitor'] = this.monitor;
    fields['group'] = this.group;


    this.okService.download("reports/workerlocationsettings",fields);

  }

}
